import { SerializedError } from '@reduxjs/toolkit';

export const convertSerializedErrorToError = (error: SerializedError) => ({
  ...error,
  name: error.name || '',
  message: error.message || '',
});
